import { CardHead } from './CardHead';
import { CardGrid } from './CardGrid';
import { CardActions } from './CardActions';

export const CardContainer = ({ canSign, setCanSign, setErrorMessageKey, setFileName }) => {
    return (
        <div className="card-container">
            <CardHead />
            <CardGrid setCanSign={setCanSign} setErrorMessageKey={setErrorMessageKey}  setFileName={setFileName}/>
            <CardActions canSign={canSign} />
        </div>
    );
};
